import React from 'react'
import { useTheme } from '../../contexts/ThemeContext'
import { useBranding } from '../../contexts/BrandingProvider'

interface LogoProps {
  className?: string
  alt?: string
  forceDefault?: boolean
}

export const Logo: React.FC<LogoProps> = ({
  className = 'h-10 w-auto transition-transform group-hover:scale-105',
  alt,
  forceDefault,
}) => {
  const { resolvedTheme } = useTheme()
  const { currentLogoUrl, branding } = useBranding()
  const defaultLogo = resolvedTheme === 'dark' ? '/logo_white.png' : '/logo.png'
  const src = forceDefault ? defaultLogo : (currentLogoUrl ?? defaultLogo)
  const altText = alt ?? (forceDefault ? 'Open1031' : (branding?.orgName ?? 'Open1031'))

  const heightMatch = className.match(/h-(\d+)/)
  const height = heightMatch ? `${parseInt(heightMatch[1]) * 0.25}rem` : '2.5rem'

  return (
    <img
      src={src}
      alt={altText}
      className={className}
      style={{ height }}
    />
  )
}
